<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Induction Module</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <p>
    Read through the introduction as well as any other content sections that may
    appear. You may need to scroll down to read more or to go to the next section.
    At the end, answer all the questions by clicking an answer to be yes
    (coloured) or no (gray). When you are done, save your answers. You will
    automatically be returned to the list of modules.
  </p>

  <mat-stepper
    orientation="vertical"
    [linear]="true"
    (selectionChange)="onSelectionChange($event)">
    <mat-step>
      <ng-template matStepLabel>Introduction</ng-template>
      <h6 class="mt-2">{{ inductionService.data.modules[module_index].name }}</h6>
      <app-safe-rich-content [html]="inductionService.data.modules[module_index].description"></app-safe-rich-content>

      <div class="d-flex justify-content-end mt-3">
        <button mat-raised-button matStepperNext class="m-1 mr-2" color="primary">
          <mat-icon>arrow_forward</mat-icon> Next
        </button>
      </div>
    </mat-step>

    <ng-container *ngFor="let content of inductionService.data.modules[module_index].contents; let i = index">
      <mat-step *ngIf="content.content">
        <ng-template matStepLabel>Section {{ i+1 }}</ng-template>
        <h6 class="mt-2">{{ content.name }}</h6>
        <app-safe-rich-content [html]="content.content"></app-safe-rich-content>

        <div class="d-flex flex-wrap justify-content-end mt-3">
          <button
            mat-raised-button
            matStepperPrevious
            class="m-1 mr-2"
            color="secondary">
            <mat-icon>arrow_back</mat-icon> Back
          </button>
          <button mat-raised-button matStepperNext class="m-1 mr-2" color="primary">
            <mat-icon>arrow_forward</mat-icon> Next
          </button>
        </div>
      </mat-step>
    </ng-container>

    <mat-step>
      <ng-template matStepLabel>Questions</ng-template>

      <ng-container *ngFor="let question of inductionService.data.modules[module_index].questions; let i = index">
        <p class="mt-2">
          <b>{{ question.question }}</b>
        </p>

        <p>Click to slide the options on or off.</p>

        <ng-container *ngFor="let answer of inductionService.data.modules[module_index].questions[i].answers; let j = index">
          <div>
            <mat-slide-toggle [(ngModel)]="inductionService.data.modules[module_index].questions[i].answers[j].user_answer">
              {{ answer.answer_text }}
            </mat-slide-toggle>
          </div>
        </ng-container>
      </ng-container>

      <p class="mt-2" *ngIf="!inductionService?.data?.modules[module_index]?.questions?.length">
        There are no questions loaded for this module. Please contact {{ utils.getAppName() }} for assistance.
      </p>

      <div class="d-flex flex-wrap justify-content-end mt-3">
        <button
          mat-raised-button
          matStepperPrevious
          class="m-1 mr-2"
          color="secondary">
          <mat-icon>arrow_back</mat-icon> Back
        </button>

        <button
          mat-raised-button
          class="m-1 mr-2"
          type="button"
          color="primary"
          [disabled]="!inductionService?.data?.modules[module_index]?.questions?.length"
          (click)="onSaveAnswers()">
          <mat-icon>save</mat-icon> Save Answers
        </button>
      </div>
    </mat-step>
  </mat-stepper>
</mat-dialog-content>
